import { Stack } from '@mui/material'

import { useBulkImportStore } from '../../hooks/useBulkImportStore'

import { FirstStepBulkImport } from './FirstStep/FirstStepBulkImport'
import { SecondStepBulkImport } from './SecondStep/SecondStepBulkImport'
import { ThirdStepBulkImport } from './ThirdStepBulkImport/ThirdStepBulkImport'

const Components = [FirstStepBulkImport, SecondStepBulkImport, ThirdStepBulkImport]

export function StepsContainerBulkImport() {
  const step = useBulkImportStore(store => store.step)

  const StepComponent = Components[step - 1]

  return (
    <Stack
      sx={{
        paddingX: '20px',
        flex: '1 0 0',
        height: '100%',
        overflow: 'hidden',
        ...(step !== 3 && { alignItems: 'center' }),
      }}
    >
      <StepComponent />
    </Stack>
  )
}
